import { Menu, Transition } from "@headlessui/react"

import React, { useEffect, useState } from 'react';
import { signOut, useSession } from "next-auth/react"
import Link from "next/link"
import Image from 'next/image';
import { Fragment } from "react"

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

export default function ProfileNav() {
    const [user, setUser] = useState(null);
    const [profileImgPreview, setProfileImgPreview] = useState<string | null>(null);
    const session = useSession();

    useEffect(() => {
        // Only fetch user data if authenticated
        if (session.status === "authenticated") {
            const fetchUser = async () => {
                try {
                    const response = await fetch("/api/user");
                    if (!response.ok) {
                        window.location.href = `${process.env.NEXT_PUBLIC_BASE_URL}`;
                        return;
                    }

                    const data = await response.json();
                    if (data.user) {
                        setUser(data.user);
        
                        if (data.user.profileImg) {
                            const profileImgUrl = data?.user?.profileImg ? 
                                data?.user.profileImg.startsWith('https://lh3.googleusercontent.com/a') ? 
                                    data?.user.profileImg.replace('s96-c', 's192-c') : 
                                    `/api/profileImg?filename=${encodeURIComponent(data.user.profileImg)}` : 
                                "../../../images/myaccsubscription/profile-icon.svg";
                            setProfileImgPreview(profileImgUrl);
                        }
                    }
                } catch (err) {
                    console.error("Error fetching user data:", err);
                }
            };
        
            fetchUser();
        }
    }, [session.status]);
    
    return (
        <>
            {session.status === "authenticated" ?
                (<>
                    <Menu as="div" className="relative ml-3">
                        <div>
                            <Menu.Button className="relative top-1 flex rounded-full bg-gray-800 text-lg focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                                <span className="absolute -inset-1.5" />
                                <span className="sr-only">Open user menu</span>
                                {session?.data?.user ? (
                                    <Image
                                        className="h-8 w-8 rounded-full"
                                        src={profileImgPreview || "../../../images/myaccsubscription/profile-icon.svg"}
                                        alt="user_profile"
                                        width={32}
                                        height={32}
                                        priority={false}
                                    />
                                ) : (
                                    <div className="bg-slate-950 h-8 w-8 rounded-full">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.25" stroke="white" className="h-8 w-8">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                    </div>
                                )}

                            </Menu.Button>
                        </div>
                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <Menu.Item>
                                    <a href="/dashboard"
                                        className={classNames('w-full block px-4 py-2 text-lg text-gray-700 hover:bg-gray-100')}
                                    >Dashboard</a>
                                </Menu.Item>
                                <Menu.Item>
                                    <a href={`${process.env.NEXT_PUBLIC_BASE_URL}/dashboard/settings`}
                                        className={classNames('w-full block px-4 py-2 text-lg text-gray-700 hover:bg-gray-100')}
                                    >Account settings</a>
                                </Menu.Item>
                                <Menu.Item>
                                    <a href={`${process.env.NEXT_PUBLIC_BASE_URL}/dashboard/subscription`}
                                        className={classNames('w-full block px-4 py-2 text-lg text-gray-700 hover:bg-gray-100')}
                                    >
                                        Subscription
                                    </a>
                                </Menu.Item>
                                <Menu.Item>
                                    <a href="/support/faq"
                                        className={classNames('w-full block px-4 py-2 text-lg text-gray-700 hover:bg-gray-100')}
                                    >
                                        FAQ
                                    </a>
                                </Menu.Item>
                                <Menu.Item>
                                    <a href="/support/contact"
                                        className={classNames('w-full block px-4 py-2 text-lg text-gray-700 hover:bg-gray-100')}
                                    >
                                        Support
                                    </a>
                                </Menu.Item>
                                <Menu.Item>
                                    <button type="button"
                                        onClick={() => signOut()}
                                        className={classNames('w-full block px-4 py-2 text-lg text-gray-700 border-t-2 hover:bg-gray-100')}
                                    >
                                        Sign out
                                    </button>
                                </Menu.Item>
                            </Menu.Items>
                        </Transition>
                    </Menu>
                </>) : (
                    <div className="pt-0">
                        <div className="member-login-button">
                            <a className="mybtn mybtn--warning d-flex gap-2 fw-medium text-center"
                                href="/account/login">
                                &nbsp;MEMBERS LOGIN
                                {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7 ms-2">
                                    <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clipRule="evenodd" />
                                </svg> */}
                                <svg width="17" height="20" viewBox="0 0 17 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.30762 9.99939C11.0649 9.99939 13.3076 7.75728 13.3076 4.99938C13.3076 2.24149 11.0649 0 8.30762 0C5.55034 0 3.30762 2.2421 3.30762 5C3.30762 7.7579 5.54972 10 8.30762 10V9.99939Z" fill="currentColor" />
                                    <path d="M8.30763 20.0002C11.6498 20.0002 14.6385 18.4775 16.6153 16.0849C16.0964 13.3887 14.2886 11.1428 11.8614 10.0156C10.8539 10.7307 9.63043 11.154 8.30763 11.154C6.98482 11.154 5.76135 10.7307 4.75383 10.0156C2.32725 11.1422 0.519497 13.3887 0 16.0849C1.9768 18.4769 4.96545 20.0002 8.30763 20.0002Z" fill="currentColor" />
                                </svg>
                            </a>
                        </div>
                    </div>
                )}
        </>
    )
}